import { createAsyncThunk } from "@reduxjs/toolkit";
import constantsApi from "app/api/constants";

export const getIndustries = createAsyncThunk(
    "constants/getIndustries",
    async () => {
        const response = await constantsApi.getIndustries()

        return response
    }
)

export const getCountry = createAsyncThunk(
    "constants/getCountry",
    async () => {
        const response = await constantsApi.getCountry()

        return response
    }
)

export const getLanguages = createAsyncThunk(
    "constants/getLanguages",
    async (payload) => {
        const response = await constantsApi.getLanguages(payload)

        return response
    }
)

export const getApiLanguages = createAsyncThunk(
    "constants/getApiLanguages",
    async (payload) => {
        const response = await constantsApi.getApiLanguages(payload)

        return response
    }
)

export const getFallbackLanguage = createAsyncThunk(
    "constants/getFallbackLanguage",
    async () => {
        const response = await constantsApi.getFallbackLanguage()

        return response
    }
)

export const getFallbackApiLanguage = createAsyncThunk(
    "constants/getFallbackApiLanguage",
    async () => {
        const response = await constantsApi.getFallbackApiLanguage()

        return response
    }
)

// Thunk to fetch language data specifically for the preview
export const fetchPreviewLanguageData = createAsyncThunk(
    "productPage/fetchPreviewLanguageData",
    async (payload, { rejectWithValue }) => {
        try {
            const languageCode = payload?.language || 'EN'; // Default to EN if not provided
            const response = await constantsApi.getLanguages(languageCode);
            return response;
        } catch (error) {
            console.error("Error fetching preview language data:", error);
            // Optionally pass error data to the reducer
            return rejectWithValue(error.response?.data || 'Failed to fetch preview language');
        }
    }
);